import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  addApiCasesTable,
  createDynamicThunk,
} from "../../../../service/requestHandler";

export const securityHubList = createDynamicThunk(
  "securityHubList",
  "/report/api/v1/securityHub/fixedFindingsList",
  ["pageNumber", "itemsPerPage"]
);

export const securityHubCurrentList = createDynamicThunk(
  "securityHubCurrentList",
  "/report/api/v1/securityHub/openFindingsList",
  ["pageNumber", "itemsPerPage"]
);

export const SecurityHubCurrentListCount = createDynamicThunk(
  "SecurityHubCurrentListCount",
  "/api/v1/aws/getSecurityHubListBySearchBasedOnCount"
);

export const SecurityHubDrilldownList = createDynamicThunk(
  "SecurityHubDrilldownList",
  "/report/api/v1/securityHub/openFindingsList",
  ["pageNumber", "itemsPerPage"]
);

export const SecurityHubDrilldownListCount = createDynamicThunk(
  "SecurityHubDrilldownListCount",
  "/api/v1/aws/getSecurityHubListBySearchBasedOnCount"
);

export const SecurityHubTargetdatemissed = createDynamicThunk(
  "SecurityHubTargetdatemissed",
  "/report/api/v1/securityHub/getSecurityHubListByTargetDateMissed",
  ["pageNumber", "itemsPerPage"]
);

export const SecurityHubTargetdatemissedCount = createDynamicThunk(
  "SecurityHubTargetdatemissedCount",
  "/api/v1/aws/targetDateMissedListCount"
);

export const securityHubCount = createDynamicThunk(
  "securityHubCount",
  "/api/v1/aws/getFixedSecurityHubListBySearchBasedOnCount"
);

export const securityHubNonComplianceByaccountIdAPI = createDynamicThunk(
  "securityHubNonComplianceByaccountIdAPI",
  "/report/api/v1/securityHub/getAccountWiseCount"
);

export const securityHubNonComplianceByTypeAPI = createDynamicThunk(
  "securityHubNonComplianceByTypeAPI",
  "/report/api/v1/securityHub/getNonCompliantByResourceWiseCount"
);

export const getSHFTargetMissedItems = createDynamicThunk(
  "getSHFTargetMissedItems",
  "/report/api/v1/securityHub/getTargetDates"
);

export const getSHFTargetDueTrend = createDynamicThunk(
  "getSHFTargetDueTrend",
  "/report/api/v1/securityHub/getTargetDateDueCounts"
);

export const getSHFOpenFindings = createDynamicThunk(
  "getSHFOpenFindings",
  "/report/api/v1/securityHub/getOpenFindingsCount"
);

export const getSHFClosedFindings = createDynamicThunk(
  "getSHFClosedFindings",
  "/report/api/v1/securityHub/getClosedFindingsCount"
);

export const SHFFindingsTrend = createDynamicThunk(
  "SHFFindingsTrend",
  "/report/api/v1/securityHub/getGraphListData"
);

export const NonComplianceAppCri = createDynamicThunk(
  "NonComplianceAppCri",
  "/report/api/v1/securityHub/getCriticalityWiseCount"
);

export const NonComplianceBySeverity = createDynamicThunk(
  "NonComplianceBySeverity",
  "/report/api/v1/securityHub/getSeverityStatusCount"
);


export const initialState = {
  securityHubListData: [],
  securityHubListLoading: false,
  securityHubCurrentListData: [],
  securityHubCurrentListLoading: false,
  SecurityHubCurrentListCountData: [],
  SecurityHubCurrentListCountLoading: false,
  SecurityHubDrilldownListData: [],
  SecurityHubDrilldownListLoading: false,
  SecurityHubDrilldownListCountData: [],
  SecurityHubDrilldownListCountLoading: false,
  SecurityHubTargetdatemissedData: [],
  SecurityHubTargetdatemissedLoading: false,
  SecurityHubTargetdatemissedCountData: [],
  SecurityHubTargetdatemissedCountLoading: false,
  securityHubCountData: [],
  securityHubCountLoading: false,
  securityHubNonComplianceByaccountIdAPIData: [],
  securityHubNonComplianceByaccountIdAPILoading: false,
  securityHubNonComplianceByTypeAPIData: [],
  securityHubNonComplianceByTypeAPILoading: false,
  getSHFTargetMissedItemsData: [],
  getSHFTargetMissedItemsLoading: false,
  getSHFTargetDueTrendData: [],
  getSHFTargetDueTrendLoading: false,
  getSHFOpenFindingsData: [],
  getSHFOpenFindingsLoading: false,
  getSHFClosedFindingsData: [],
  getSHFClosedFindingsLoading: false,
  SHFFindingsTrendData: [],
  SHFFindingsTrendLoading: false,
  NonComplianceAppCriData: [],
  NonComplianceAppCriLoading: false,
  NonComplianceBySeverityData: [],
  NonComplianceBySeverityLoading: false,
};

export const SecurityHubSlice = createSlice({
  name: "SecurityHubSlice",
  initialState,
  reducers: {
    resetSecurityHubSlice: () => initialState,
    resetSecurityHubData: () => initialState,
    resetSecurityHubListData: (state) => {
      state.securityHubListData = [];
      state.securityHubCurrentListData = [];
      state.securityHubListLoading = true;
      state.securityHubCurrentListLoading = true;
    },
  },
  extraReducers: (builder) => {
    addApiCasesTable(
      builder,
      securityHubList,
      "securityHubListData",
      "securityHubCount"
    );
    addApiCasesTable(
      builder,
      securityHubCurrentList,
      "securityHubCurrentListData",
      "SecurityHubCurrentListCountData"
    );
    addApiCasesTable(
      builder,
      SecurityHubDrilldownList,
      "SecurityHubDrilldownListData",
      "SecurityHubDrilldownListCountData"
    );
    addApiCasesTable(
      builder,
      SecurityHubTargetdatemissed,
      "SecurityHubTargetdatemissedData",
      "SecurityHubTargetdatemissedCountData"
    );
    addApiCases(
      builder,
      securityHubNonComplianceByaccountIdAPI,
      "securityHubNonComplianceByaccountIdAPIData"
    );
    addApiCases(
      builder,
      securityHubNonComplianceByTypeAPI,
      "securityHubNonComplianceByTypeAPIData"
    );
    addApiCases(
      builder,
      getSHFTargetMissedItems,
      "getSHFTargetMissedItemsData"
    );
    addApiCases(builder, getSHFTargetDueTrend, "getSHFTargetDueTrendData");
    addApiCases(builder, getSHFOpenFindings, "getSHFOpenFindingsData");
    addApiCases(builder, getSHFClosedFindings, "getSHFClosedFindingsData");
    addApiCases(builder, SHFFindingsTrend, "SHFFindingsTrendData");
    addApiCases(builder, NonComplianceAppCri, "NonComplianceAppCriData");
    addApiCases(
      builder,
      NonComplianceBySeverity,
      "NonComplianceBySeverityData"
    );
  },
});

export const { resetSecurityHubSlice, resetSecurityHubData, resetSecurityHubListData } =
  SecurityHubSlice.actions;
export default SecurityHubSlice.reducer;
